import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { CountryCodeSelectModule } from 'src/app/widgets/form/fields/country-code-select/country-code-select.module';
import { SendApplyFinancingTextDialogComponent } from './send-apply-financing-text-dialog.component';

@NgModule({
  declarations: [SendApplyFinancingTextDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    CountryCodeSelectModule
  ],
  exports: [SendApplyFinancingTextDialogComponent]
})
export class SendApplyFinancingTextDialogModule { }
